import { render, staticRenderFns } from "./WootKeyShortcutModal.vue?vue&type=template&id=fddaa52c&scoped=true"
import script from "./WootKeyShortcutModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WootKeyShortcutModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WootKeyShortcutModal.vue?vue&type=style&index=0&id=fddaa52c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddaa52c",
  null
  
)

export default component.exports